module.exports = __webpack_public_path__ + "img/businessTitle.4c17abdf.svg";